import aluLogo from '@assets/LABOR CONNECT LOGO WHITE PHONE.png';
import defaultLogo from '@assets/LABOR CONNECT LOGO WHITE PHONE.png';
import { resolveBackendAssetUrl } from './assetUrl';

const UNION_CONFIG = {
  LWU: {
    shortName: 'LWU',
    fullName: 'Luzon Workers Union',
    logo: aluLogo,
    colors: {
      headerGradient: 'linear-gradient(135deg, #d14c17, #a70606)',
      headerBackGradient: 'linear-gradient(135deg, #d14c17, #a70606)',
      bannerGradient: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
      footerGradient: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
    },
  },
  PPEU: {
    shortName: 'PPEU',
    fullName: 'Philippine Professional Employees Union',
    logo: aluLogo,
    colors: {
      headerGradient: 'linear-gradient(135deg, #ca8a04, #a16207)',
      headerBackGradient: 'linear-gradient(135deg, #ca8a04, #a16207)',
      bannerGradient: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
      footerGradient: 'linear-gradient(135deg, #1e3a8a, #1d4ed8)',
    },
  },
  // Backward-compatible aliases for existing records
  ALU: undefined,
  APSUTEU: undefined,
};
// Resolve legacy keys to new keys
UNION_CONFIG.ALU = UNION_CONFIG.LWU;
UNION_CONFIG.APSUTEU = UNION_CONFIG.PPEU;

const SHARED_BLUE = 'linear-gradient(135deg, #1e3a8a, #1d4ed8)';

export const COLOR_THEMES = {
  red: {
    headerGradient: 'linear-gradient(135deg, #d14c17, #a70606)',
    headerBackGradient: 'linear-gradient(135deg, #d14c17, #a70606)',
    bannerGradient: SHARED_BLUE,
    footerGradient: SHARED_BLUE,
  },
  yellow: {
    headerGradient: 'linear-gradient(135deg, #ca8a04, #a16207)',
    headerBackGradient: 'linear-gradient(135deg, #ca8a04, #a16207)',
    bannerGradient: SHARED_BLUE,
    footerGradient: SHARED_BLUE,
  },
  green: {
    headerGradient: 'linear-gradient(135deg, #16a34a, #15803d)',
    headerBackGradient: 'linear-gradient(135deg, #16a34a, #15803d)',
    bannerGradient: SHARED_BLUE,
    footerGradient: SHARED_BLUE,
  },
  purple: {
    headerGradient: 'linear-gradient(135deg, #9333ea, #7e22ce)',
    headerBackGradient: 'linear-gradient(135deg, #9333ea, #7e22ce)',
    bannerGradient: SHARED_BLUE,
    footerGradient: SHARED_BLUE,
  },
  orange: {
    headerGradient: 'linear-gradient(135deg, #ea580c, #c2410c)',
    headerBackGradient: 'linear-gradient(135deg, #ea580c, #c2410c)',
    bannerGradient: SHARED_BLUE,
    footerGradient: SHARED_BLUE,
  },
};

const DEFAULT_BRANDING = {
  shortName: 'LWU',
  fullName: 'Luzon Workers Union',
  logo: defaultLogo,
  colors: UNION_CONFIG.LWU.colors,
};

// Module-level store for dynamic branding data from the backend
let _dynamicBranding = {};

/**
 * Set dynamic branding data fetched from the backend.
 * Call this on app load / after auth with the affiliations array from
 * GET /api/union-data/dropdown (or admin endpoint).
 *
 * @param {Array} affiliations - Array of { acronym, fullName, logoPath }
 */
export function setBrandingData(affiliations) {
  _dynamicBranding = {};
  if (!Array.isArray(affiliations)) return;
  for (const aff of affiliations) {
    if (!aff?.acronym) continue;
    const key = aff.acronym.trim().toUpperCase();
    const logoUrl = aff.logoPath ? resolveBackendAssetUrl(aff.logoPath) : null;
    const rawVersion = aff.updatedAt || aff.updated_at || '';
    const logoVersion = rawVersion ? Date.parse(rawVersion) || String(rawVersion).trim() : '';
    const logoWithVersion = (logoUrl && logoVersion)
      ? `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}v=${encodeURIComponent(String(logoVersion))}`
      : logoUrl;
    _dynamicBranding[key] = {
      shortName: key,
      fullName: aff.fullName || key,
      logo: logoWithVersion, // null means "use static fallback"
      colors: (aff.colorTheme && COLOR_THEMES[aff.colorTheme.toLowerCase()]) || UNION_CONFIG[key]?.colors || DEFAULT_BRANDING.colors,
    };
  }
}

export function getUnionBranding(unionAffiliation) {
  if (!unionAffiliation) return DEFAULT_BRANDING;
  const key = unionAffiliation.trim().toUpperCase();

  // Check dynamic branding first
  const dynamic = _dynamicBranding[key];
  if (dynamic) {
    // If dynamic entry has a logo URL, use it; otherwise fall back to static
    const staticConfig = UNION_CONFIG[key];
    return {
      ...dynamic,
      logo: dynamic.logo || staticConfig?.logo || DEFAULT_BRANDING.logo,
      colors: dynamic.colors || staticConfig?.colors || DEFAULT_BRANDING.colors,
    };
  }

  return UNION_CONFIG[key] || DEFAULT_BRANDING;
}
